import axios from 'axios';
import { rawreq,req } from './axiosFun';

// 统计分析 查询 渠道客户
export const queryReportQdList = (params) => { return rawreq("post", "/api/statisticReport/queryReportQdList", params) };

// 统计分析 查询 机构客户
export const queryReportJgList = (params) => { return rawreq("post", "/api/statisticReport/queryReportJgList", params) };



// WEBPACK FOOTER //
// ./src/api/report.js